import { INPUT_TYPES } from "./constants";
import * as _ from "lodash-es";

const checkFormCode = (formCode) => {
  if (!formCode) {
    throw `Expected non-empty string, but got '${formCode}'`;
  }
};

export const isAdminForm = (formCode) => {
  checkFormCode(formCode);
  return formCode === "admin";
};

export const isEnabledOrMandatory = (value, formCode) => {
  checkFormCode(formCode);
  if (value === undefined) {
    return true;
  }
  if (typeof value === "boolean") {
    return value;
  }
  if (value[formCode] !== undefined) {
    return value[formCode];
  }
  return value.default;
};

export const isPlacementMatched = (placement, allowedPlacement) => {
  if (!placement || !allowedPlacement) {
    // No placement checking
    return true;
  }
  return placement === allowedPlacement;
};

export const isEnabled = (value, formCode, placement = null, allowedPlacement = null) => {
  let result;
  if (isAdminForm(formCode) && _.isObject(value)) {
    result = Object.values(value).filter((v) => v === true).length > 0;
  } else {
    result = isEnabledOrMandatory(value, formCode);
  }
  return result && isPlacementMatched(placement, allowedPlacement);
};

export const isMandatory = (value, formCode) => {
  if (isAdminForm(formCode)) {
    return false;
  }
  return isEnabledOrMandatory(value, formCode);
};

const iterateFields = (metaFields, blockName) => {
  const block = metaFields[blockName];
  return (
    Object.keys(block)
      .filter((fieldName) => fieldName !== "_meta")
      .map((fieldName) => block[fieldName])
      // Field may be undefined (see `temporary_new_field_name`)
      .filter((field) => field)
  );
};

export const isBlockEnabled = (
  metaFields,
  blockName,
  formCode,
  allowedPlacement = null,
) =>
  iterateFields(metaFields, blockName).some((field) =>
    isEnabled(field.enabled, formCode, field.placement, allowedPlacement),
  );

export const toggleBlock = (metaFields, blockName, formCode, value) =>
  iterateFields(metaFields, blockName).forEach(
    (field) => (field.enabled[formCode] = value),
  );

/**
 * Return compoent's name by it's type.
 *
 * @param {String} inputType Input type constant
 * @returns {String} input component
 */
export const getInputComponent = (inputType) => {
  switch (inputType) {
    case INPUT_TYPES.SELECT:
      return "b-select";
    case INPUT_TYPES.MULTISELECT:
      return "Multiselect";
    case INPUT_TYPES.CHECKBOX:
      return "b-checkbox-group";
    case INPUT_TYPES.RADIO:
      return "b-radio-group";
    case INPUT_TYPES.TEXTAREA:
      return "b-textarea";
    case INPUT_TYPES.TEXTAREA_YES_NO:
      return "TextAreaYesNo";
    default:
      return "b-input";
  }
};
